import { createContext } from 'react';
import { ContextValue } from './types';

export const context = createContext<ContextValue>(undefined!);

context.displayName = 'i18n';
